import { DatePipe } from '@angular/common';
import {
	ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild
} from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SolicitacaoCompraItemCotacao } from "../managers/solicitacao-compra-item-cotacao";
import { ClienteSingletonService } from '../singletons/cliente-singleton.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CORE_IMPORTS } from '../providers/module-providers';

@Component({	
	standalone: true,
	selector: "app-item-cotacao",
	templateUrl: "Item-cotacao.html",
	styleUrls: [ "Item-cotacao.css"],
	imports: [CORE_IMPORTS],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemCotacaoComponent implements OnInit {
	
	@ViewChild('dataInput') dataInput: ElementRef;	
	@Input()
	public cot: SolicitacaoCompraItemCotacao;	
	@Input()
	public mostrarCdFabricante: boolean;
	@Input()
	public unMedida: string;	
	@Input()
	public cdProdutoForn: string;	
	@Input()
	public filiais = [];	
	@Input()
	public allExpandState = true;
	@Output()
	public recalcularCallback = new EventEmitter();
	@Output()
	public salvarCallback = new EventEmitter();
	public atualizar = false;
	dataDigitada = '';
	form: FormGroup;

	constructor(
		private zone: NgZone,
		private ref: ChangeDetectorRef,
		private snackBar: MatSnackBar,
		private datePipe: DatePipe,
		private clienteSingletonService: ClienteSingletonService,
		private fb: FormBuilder
	) { }
	
	ngOnInit () {
		this.zone;
		this.ref;
		this.ref.reattach();
		if(this.filiais.length > 1){
			if(this.cot.fornecedorFaturamento === undefined){
				this.cot.fornecedorFaturamento  = this.filiais.find(r => r.cdCliente === this.clienteSingletonService.cliente.cdCliente);
			}			
		}
		this.form = this.fb.group({
			qtCotacao: [this.cot.qtCotacao ? this.cot.qtCotacao : '0,00'],
			vlBruto: [this.cot.vlBruto ? this.cot.vlBruto.toFixed(2).replace(".",",") : '0,00'],
			pcDesconto: [this.cot.pcDesconto ? this.cot.pcDesconto.toFixed(2).replace(".",",") : '0,00'],
			dtPrevisaoEntrega: [this.cot.dtPrevisaoEntrega, this.dateValidator],
			cstOrigem: [this.cot.cstOrigem],
			ipiPcAliq: [this.cot.ipiPcAliq ? this.cot.ipiPcAliq.toFixed(2).replace(".",",") : '0,00'],
			icmsPcAliquota: [this.cot.icmsPcAliquota ? this.cot.icmsPcAliquota.toFixed(2).replace(".",",") : '0,00'],
			icmsValor: [this.cot.icmsValor ? this.cot.icmsValor.toFixed(2).replace(".",",") : '0,00'],
			icmsStPcAliquota: [this.cot.icmsStPcAliquota ? this.cot.icmsStPcAliquota.toFixed(2).replace(".",",") : '0,00'],
			icmsStValor: [this.cot.icmsStValor ? this.cot.icmsStValor.toFixed(2).replace(".",",") : '0,00'],
			vlTotal: [this.cot.vlTotal ? this.cot.vlTotal.toFixed(2).replace(".",",") : '0,00'],
			obs: [this.cot.obs],
			fornecedorFaturamento: [this.cot.fornecedorFaturamento]
		});
	}

	// eslint-disable-next-line @angular-eslint/use-lifecycle-interface
	ngOnChanges() {
	if (this.form) {
		this.form.patchValue({
			dtPrevisaoEntrega: this.cot.dtPrevisaoEntrega
		});
	}
}
	
	setDetectar (atualizar: boolean) {
		if ((!this.atualizar && atualizar) || (this.atualizar && !atualizar)) {
			this.atualizar = atualizar;
		}
	}
	
	recalcularItem (b: boolean) {
		this.cot.qtCotacao = parseFloat((this.form.value.qtCotacao).toString().replace(",","."));
		this.cot.vlBruto = parseFloat((this.form.value.vlBruto).toString().replace(",","."));
		this.cot.pcDesconto = parseFloat((this.form.value.pcDesconto).toString().replace(",","."));
		this.cot.dtPrevisaoEntrega = this.form.value.dtPrevisaoEntrega;
		this.cot.cstOrigem = this.form.value.cstOrigem;
		this.cot.ipiPcAliq = parseFloat((this.form.value.ipiPcAliq).toString().replace(",","."));
		this.cot.icmsPcAliquota = parseFloat((this.form.value.icmsPcAliquota).toString().replace(",","."));
		this.cot.icmsValor = parseFloat((this.form.value.icmsValor).toString().replace(",","."));
		this.cot.icmsStPcAliquota = parseFloat((this.form.value.icmsStPcAliquota).toString().replace(",","."));
		this.cot.icmsStValor = parseFloat((this.form.value.icmsStValor).toString().replace(",","."));
		this.cot.obs = this.form.value.obs;
		this.cot.fornecedorFaturamento = this.form.value.fornecedorFaturamento;

		this.feedbackRecalcular(
			this.cot.solicitacaoCompraItem.item.idItem + '-' + b
		);
	}

	salvarItem () {
		this.salvarCallback.emit(this.cot.solicitacaoCompraItem.item.idItem);
	}

	feedbackRecalcular (idItemCalculaAliq: string) {
		this.recalcularCallback.emit(idItemCalculaAliq);
	}


	getCdFabricante () {
		return this.cot.solicitacaoCompraItem.item.itemProduto.cdFabricante;
	}

	getDescricao () {
		return this.cot.solicitacaoCompraItem.item.nmItem;
	}

	// Métodos pra não deixar o html muito largo.

	getCdItem(cot: SolicitacaoCompraItemCotacao): string {
		return cot.solicitacaoCompraItem.item.cdItem;
	}

	validaPercentual(percent: number, name: string): boolean {
		const elem: HTMLElement = document.getElementById(name); 
		if (percent < 0) {
			elem.style.color = "red";
			
			setTimeout(
				function () { 
					elem.focus();
				},
				50
			);

			return false;
		}
		else {
			elem.style.color = "black";
		}

		return true;
	}

	onInputChange(event: any, nameControl: string) {
		let formattedInput;
		let input = event.target.value.replace(/[^\d]/g, '');
		input = input.replace(/^0+/, '');

		if(nameControl === "pcDesconto"){
			if (input.length > 5) {
				input = input.slice(0, 5);
			}
			if(input.length === 5){
				input = input.padStart(5, '0');
				formattedInput = input.slice(0, 3) + ',' + input.slice(3);
			}else{
				input = input.padStart(4, '0');
				formattedInput = input.slice(0, 2) + ',' + input.slice(2);
			}
			if(parseFloat(formattedInput) > 100){
				formattedInput = "100,00";
			}
		}else if(nameControl === "vlBruto"){
			if(input.length < 4){
				input = input.padStart(3, '0');
				formattedInput = input.slice(0, 1) + ',' + input.slice(1);
			}else{
				const integerPart = input.slice(0, -2);
				const decimalPart = input.slice(-2);
				formattedInput = integerPart + ',' + decimalPart;
			}
		}else{
			if (input.length > 4) {
				input = input.slice(0, 4);
			}
			if(input.length === 4){
				input = input.padStart(4, '0');
				formattedInput = input.slice(0, 2) + ',' + input.slice(2);
			}else{
				input = input.padStart(3, '0');
				formattedInput = input.slice(0, 1) + ',' + input.slice(1);
			}
		}

		event.target.value = formattedInput;
		this.form.controls[nameControl].setValue(formattedInput, { emitEvent: false });
		this.cot[nameControl] = Number.parseFloat(formattedInput);
		
		if(nameControl === 'icmsValor' || nameControl === 'icmsStValor'){
			this.recalcularItem(true);
		}else{
			this.recalcularItem(false);
		}
	}

	getFormattedVl(nomeCampo: string): string {
		if(this.cot[nomeCampo] != null){
			return this.cot[nomeCampo].toFixed(2).replace(".", ",");
		} else {
			return Number(0).toFixed(2).replace(".", ",");
		}
	}

	mostrarNotificacao(text: string) {
		this.snackBar.open(text, null, {
			duration: 2000
		});
	}
	
	formatarDataPrevEntrega(input: string) {
		this.cot.dtPrevisaoEntrega = this.formatarDataComBarras(input);
		this.form.get('dtPrevisaoEntrega').setValue(this.formatarComoData(input));
	}
	
	formatarDataComBarras(input: string): string {
		const maxLength = 10;
		const formattedInput = input
			.replace(/\D/g, '')
			.slice(0, maxLength);

		if (formattedInput.length >= 1) {
			this.dataDigitada =
				formattedInput.slice(0, 2) +
				(formattedInput.length >= 4
					? '/' + formattedInput.slice(2, 4)
					: '') +
				(formattedInput.length >= 8 ? '/' + formattedInput.slice(4, 8) : '');
			return this.dataDigitada;
		}
	}

	validarData(input: string) {
		const vlBruto = this.form.get('vlBruto').value;
		if(vlBruto === 0 || vlBruto === '0' || vlBruto === '0,00'){
			const control = this.form.get('dtPrevisaoEntrega');
			control?.setErrors({ dateNotValid: false });
			control?.markAsUntouched();
			return;
		}
		if(input == undefined || input == ''){
			const control = this.form.get('dtPrevisaoEntrega');
			control?.setErrors({ dateNotValid: true });
			control?.markAsTouched();
			control?.markAsDirty();
			this.cot.dtPrevisaoEntrega = '';
			return;
		}
		const partesData = input.split('/');

		if (partesData.length !== 3) {
			this.mostrarNotificacao('Formato de data inválido');
			this.cot.dtPrevisaoEntrega = '';
			return;
		}

		const dataInput = partesData[1] + '/' + partesData[0] + '/' + partesData[2];
		const dataInputFormatted = partesData[2] + '/' + partesData[1] + '/' + partesData[0];

		const date = new Date(dataInput);

		if (isNaN(date.getTime())) {
			this.mostrarNotificacao('Data inválida');
			const control = this.form.get('dtPrevisaoEntrega');
			control?.setErrors({ dateNotValid: true });
			control?.markAsTouched();
			control?.markAsDirty();
			this.cot.dtPrevisaoEntrega = '';
			return;
		}
		
		const selectedDateFormatted = this.datePipe.transform(dataInputFormatted, 'yyyy-MM-dd');
		const currentDateFormatted = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
		if (selectedDateFormatted < currentDateFormatted) {
			this.mostrarNotificacao('Data inválida. Informe uma data maior que a data atual.');
			const control = this.form.get('dtPrevisaoEntrega');
			control?.setErrors({ dateNotValid: true });
			control?.markAsTouched();
			control?.markAsDirty();
			this.cot.dtPrevisaoEntrega = '';
			return;
		}
	}

	public isStInvalid(): boolean {
		const cstOrigem = this.cot?.cstOrigem;
		const aliqSt = this.cot?.icmsStPcAliquota;
		const aliqIcms = this.cot?.icmsPcAliquota;

		const isAliqStFilled = aliqSt !== undefined && aliqSt !== null && aliqSt !== 0;
		const isAliqIcmsFilled = aliqIcms !== undefined && aliqIcms !== null && aliqIcms !== 0;
		const isCstOrigemEmpty = !cstOrigem || cstOrigem.trim() === '';

		return (isAliqStFilled || isAliqIcmsFilled) && isCstOrigemEmpty;
	}
	
	formDataPrevisaoEntregaInvalida(){
		const dtPrevisaoEntrega = this.form.get('dtPrevisaoEntrega').value;
		const vlBruto = this.form.get('vlBruto').value;

		if((dtPrevisaoEntrega == '' || dtPrevisaoEntrega == null) 
			&& (vlBruto === 0 || vlBruto === '0' || vlBruto === '0,00')){
			return false;
		}
		this.dateValidator;
		const valid = this.form.get('dtPrevisaoEntrega').valid;
		return !valid;
	}

	dateValidator(control){
		if (!control.parent) {
			return null;
		}
		const qtCotacao = control.parent.get('qtCotacao')?.value;
		const vlBruto = control.parent.get('vlBruto')?.value;
		if (((qtCotacao === 0 || qtCotacao === '0' || qtCotacao === '0,00') && (vlBruto === 0 || vlBruto === '0' || vlBruto === '0,00'))) {
			return null;
		}
		if(control.value == null) {
			return { 'dateNotValid': true };
		}
		const numeros = control.value.replace(/\D/g, '');
		const dia = numeros.substring(0, 2);
		const mes = numeros.substring(2, 4);
		const ano = numeros.substring(4);
		const currentDate = new Date();
		currentDate.setHours(0, 0, 0, 0);
		const inputDate = new Date(ano,mes-1,dia)
		return inputDate >= currentDate ? null : { 'dateNotValid': true };
	}
	
	formatarComoData(input: string): string {
		if (!input) return '';
	
		const numeros = input.replace(/\D/g, '');
		if (numeros.length === 4) {
			const dia = numeros.substring(0, 2);
			const mes = numeros.substring(2, 4);
			return `${dia}/${mes}`;
		}
		if (numeros.length < 8) return input;
	
		const dia = numeros.substring(0, 2);
		const mes = numeros.substring(2, 4);
		const ano = numeros.substring(4);
	
		return `${dia}/${mes}/${ano}`;
	}

	atualizarDtPrevisaoEntrega(data: string) {
		this.form.get('dtPrevisaoEntrega')?.setValue(data);
	}
}